import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { FaxV1 } from '@frontend/api-fax';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useNewBlockedFaxEventSubscription = () => {
  const { invalidateListBlockedFaxes } = FaxV1.FaxQueryUpdaters.useListFaxQueryUpdater();

  return useWebsocketEventSubscription(NotificationType.INBOUND_BLOCKED_FAX_NOTIFICATION, () => {
    invalidateListBlockedFaxes();
  });
};
